// Время покупки «минуты:секунды» с начала матча: 358 → «5:58».
export const formatBuyTime = (seconds: number): string => {
  const whole = Math.max(0, Math.round(seconds));
  return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, "0")}`;
};
